export default __webpack_public_path__ + "static/media/english-to-hungarian-screenshot-03.c1d55692.png";